<template lang="pug">

  v-container(fill-height)
    v-layout(justify-content align-center)
      v-flex.text-center
        h1.mb-4 {{ $t('trafik.export') }}
        //- v-btn.mx-2(v-for="year in data" color="primary" dark @click="download(year)" :href="'export/'+year") {{ year }}
        v-btn.mx-2(v-for="year, i in data" color="primary" dark @click="download(year)" :key="i" :disabled="loading") {{ year }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('traffic', {
      data: 'exports',
      loading: 'loading',
    }),
  },

  mounted() {
    if(!this.data.length) {
      this.getExports()
    }
  },

  methods: {
    ...mapActions('traffic', ['download', 'getExports']),
  }
}
</script>
